<h4>{{title}}</h4>

<form
    id="lodgePlanForm"
    name="lodgePlanForm"
    novalidate
    autocomplete="off"
    data-test-automation="lodge-plan"
    #lodgePlanForm="ngForm">
    <plan-lodgement></plan-lodgement>
    <attachments class="group"></attachments>
    <land-registry-advice class="group"></land-registry-advice>
    <general-comments class="group"></general-comments>
    <fee-summary class="group"></fee-summary>
    <agreement-and-consent class="group"></agreement-and-consent>

    <div class="container-fluid">
        <div class="button-group">
            @if (isSaveVisible()) {
                <button
                    id="saveLodgePageBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    title="Save Lodge page data | Ctrl+S"
                    (click)="save()"
                    [disabled]="isSaveDisabled()"
                    ng-dblclick="lodgePlanController.cancelDblClick($event)">
                    Save
                </button>
            }

            @if (isValidateVisible()) {
                <button
                    id="validateLodgePageBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    title="Validate Lodge page data | V"
                    (click)="validate()"
                    [disabled]="isValidateDisabled()"
                    ng-dblclick="lodgePlanController.cancelDblClick($event)">
                    Validate
                </button>
            }
            <button
                id="cancelLodgePageBtn"
                type="button"
                class="btn btn-warning nlr-btn-sm"
                title="Clears all data on the Lodge screen"
                (click)="cancel()"
                [disabled]="isCancelDisabled()">
                Cancel
            </button>
        </div>
    </div>
</form>
